<template>
    <DataTable
            ref="datatable"
            :url="api.ACTIONS.REGISTRATION_REQUESTS"
            :initial-url-search-params="params"
            :enable-add="false"
            :enable-edit="false"
            :enable-delete="false"
            :fields-hidden-main="['verified', 'provider']"
    />
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "UnregisteredAgent",
        title: 'Unregistered',
        props: {
            provider: {
                type: String,
                default: ''
            }
        },
        components: {
            DataTable
        },
        data() {
            return {
                params: new URLSearchParams()
            }
        },
        mounted() {
            this.params = new URLSearchParams();
            this.params.append('provider', this.provider);
        },
        watch: {
            provider: {
                handler(val) {
                    this.provider = val;

                    this.params = new URLSearchParams();
                    this.params.append('provider', this.provider);
                    setTimeout(() => this.$refs.datatable.reset(), 10);
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>